// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1423":"05ae12a6","1454":"05ae12a6","3308":"05ae12a6","3613":"05ae12a6","5120":"05ae12a6","5744":"05ae12a6","5775":"05ae12a6","8313":"4dceb7b2"}[chunkId] + ".chunk.css";
};